<template>
  <div>
    <!-- create dialog -->
    <custom-dialog
      :openDialog="isOpen"
      :widthDialog="'900px'"
      :classDialog="'create-dialog job-create'"
      :offsetTop="'0px !important'"
      @closeDialog="$emit('closeDialog')"
      @closed="$emit('dialogClosed')"
      :appendToBody="true"
      :modalAppendToBody="true"
    >
      <template #body>
        <h3 class="dialogTitle margin-left-0">Cấu hình Trang tổng quan</h3>
        <div style="display: flex">
          <el-form ref="form" label-position="left" label-width="120px">
            <draggable
              v-model="currentListItem"
              @change="changeSort"
              group="people"
              @start="drag = true"
              @end="drag = false"
              style="display: flex; flex-wrap: wrap"
            >
              <div
                v-for="element in currentListItem"
                :key="element.key"
                class="row-item element-dashboard"
                style="width: calc(50% - 10px)"
              >
                <el-row :gutter="24" class="row-item-content">
                  <el-col :span="20">
                    <div class="row-item-header" style="font-size: 15px">
                      <i :class="element.class" style="margin-right: 10px"></i
                      >{{ element.name }}
                    </div>
                  </el-col>
                  <el-col :span="4">
                    <el-switch
                      :value="element.active"
                      active-color="#13ce66"
                      inactive-color=""
                      :active-value="true"
                      :inactive-value="false"
                      class="style-fullWidth"
                      @change="() => changeActiveElement(element)"
                    >
                    </el-switch>
                  </el-col>
                </el-row>
              </div>
            </draggable>
          </el-form>
        </div>
      </template>
      <template #footer>
        <div class="flex-row flex__right form-button__action margin-top-10">
          <el-button
            type="info"
            size="mini"
            class="btn__cancel btn-none__border"
            @click="$emit('closeDialog')"
          >
            <span class="flex-row flex__center">
              <i class="font-size__small el-icon-circle-close-outline"></i>
              &nbsp;Đóng
            </span>
          </el-button>
          <el-button
            size="mini"
            type="success"
            class="addDocs color__white bg__blue btn-none__border"
            @click="submit"
          >
            <span class="flex-row flex__center">
              <i class="font-size__small far fa-arrow-alt-circle-right"></i>
              &nbsp;Lưu
            </span>
          </el-button>
        </div>
      </template>
    </custom-dialog>
  </div>
</template>

<script>
import CustomDialog from "../../common/custom-dialog";
import draggable from "vuedraggable";
import utils from "../../../services/utils";
import dashBoardService from "../../../services/dashBoardService";
export default {
  name: "setting-display-dialog",
  props: [
    "isOpen",
    "isVisibleIncommingDoc",
    "isVisibleOutgoingDoc",
    "isVisibleCongViec",
    "isVisibleChoBanHanh",
    "isVisibleChoTiepNhan",
    "configs",
  ],
  components: {
    CustomDialog,
    draggable,
  },
  data() {
    return {
      currentListItem: [],
      listItem: [
        {
          key: "VB_DEN_LIST",
          name: "Danh sách văn bản đến",
          active: true,
          class: "far fa-inbox-in fa-fw",
          visible: true,
        },
        {
          key: "VB_DI_LIST",
          name: "Danh sách văn bản đi",
          active: false,
          class: "far fa-inbox-out fa-fw",
          visible: true,
        },
        {
          key: "VB_CHO_BAN_HANH",
          name: "Danh sách văn bản chờ ban hành",
          active: true,
          visible: true,
          class: "far fa-inbox-in fa-fw",
        },
        {
          key: "VB_CHO_TIEP_NHAN",
          name: "Danh sách văn bản chờ tiếp nhận",
          active: true,
          visible: true,
          class: "far fa-inbox-in fa-fw",
        },
        {
          key: "CV_DUOC_GIAO_LIST",
          name: "Danh sách công việc được giao",
          active: true,
          visible: true,
          class: "fal fa-briefcase",
        },
        {
          key: "CV_TOI_GIAO_LIST",
          name: "Danh sách công việc tôi giao",
          active: true,
          visible: true,
          class: "fal fa-briefcase",
        },
        {
          key: "VB_DEN_CHART",
          name: "Biểu đồ văn bản đến",
          active: true,
          visible: true,
          class: "fas fa-chart-bar",
        },
        {
          key: "VB_DI_CHART",
          name: "Biểu đồ văn bản đi",
          active: true,
          visible: true,
          class: "fas fa-chart-bar",
        },
        {
          key: "CV_TOI_GIAO_CHART",
          name: "Biểu đồ công việc tôi giao",
          active: true,
          visible: true,
          class: "fal fa-chart-pie",
        },
        {
          key: "CV_DUOC_GIAO_CHART",
          name: "Biểu đồ công việc được giao",
          active: true,
          visible: true,
          class: "fal fa-chart-pie",
        },
      ],
    };
  },

  created() {
    this.filterListItem();
  },
  methods: {
    filterListItem() {
      this.listItem = this.listItem.map((x) => {
        switch (x.key) {
          case "VB_DEN_LIST":
          case "VB_DEN_CHART":
            return {
              ...x,
              visible: this.isVisibleIncommingDoc,
              active: this.configs.indexOf(x.key) !== -1,
              order:
                this.configs.indexOf(x.key) !== -1
                  ? this.configs.indexOf(x.key)
                  : 1000,
            };
          case "VB_DI_LIST":
          case "VB_DI_CHART":
            return {
              ...x,
              visible: this.isVisibleOutgoingDoc,
              active: this.configs.indexOf(x.key) !== -1,
              order:
                this.configs.indexOf(x.key) !== -1
                  ? this.configs.indexOf(x.key)
                  : 1000,
            };
          case "VB_CHO_BAN_HANH":
            return {
              ...x,
              visible: this.isVisibleChoBanHanh,
              active: this.configs.indexOf(x.key) !== -1,
              order:
                this.configs.indexOf(x.key) !== -1
                  ? this.configs.indexOf(x.key)
                  : 1000,
            };
          case "VB_CHO_TIEP_NHAN":
            return {
              ...x,
              visible: this.isVisibleChoTiepNhan,
              active: this.configs.indexOf(x.key) !== -1,
              order:
                this.configs.indexOf(x.key) !== -1
                  ? this.configs.indexOf(x.key)
                  : 1000,
            };
          case "CV_DUOC_GIAO_LIST":
          case "CV_TOI_GIAO_LIST":
          case "CV_TOI_GIAO_CHART":
          case "CV_DUOC_GIAO_CHART":
            return {
              ...x,
              visible: this.isVisibleCongViec,
              active: this.configs.indexOf(x.key) !== -1,
              order:
                this.configs.indexOf(x.key) !== -1
                  ? this.configs.indexOf(x.key)
                  : 1000,
            };
          default:
            return x;
        }
      });
      this.currentListItem = this.listItem
        .filter((element) => element.visible)
        .sort((item1, item2) => {
          return utils.compareElementDashBoard(item1, item2);
        });
    },
    changeSort() {
      console.log(this.currentListItem);
    },
    changeActiveElement(element) {
      this.currentListItem = this.currentListItem.map((item) => {
        if (item.key === element.key) {
          return {
            ...item,
            active: !item.active,
          };
        }
        return item;
      });
    },
    submit() {
      let newDataConfigs = this.currentListItem.map((item) => {
        return {
          key: item.key,
          active: item.active,
        };
      });
      dashBoardService
        .updateSettings({
          data: {
            currentConfigs: newDataConfigs,
          },
        })
        .then((res) => {
          this.notify("Thành công", "Cập nhật cấu hình thành công!", "success", 2000);
          this.$emit("success", { newConfigs: newDataConfigs });
        })
        .catch(() => {
          this.notify("Lỗi", "Cập nhật cấu hình thất bại!", "error", 2000);
        });
    },
  },
};
</script>

<style scoped>
.row-item .row-item-content {
  margin-left: 0px !important;
  margin-right: 0px !important;
}

.row-item .row-item-content .el-col {
  height: 42px;
  display: flex;
  align-items: center;
}
.row-item .row-item-header {
  color: var(--color-dark);
  font-weight: bold;
  line-height: 30px;
}

.row-item .row-item-content .el-col:first-child {
  padding-left: 0px !important;
}

.element-dashboard:nth-child(2n + 1) {
  margin-right: 10px;
}

.element-dashboard:nth-child(2n) {
  margin-left: 10px;
}

.element-dashboard {
  margin-top: 5px;
  margin-bottom: 5px;
  padding-left: 12px;
  border: 1px solid rgb(229, 229, 229);
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/components/settingDisplay.vue